import React, { useState } from 'react';
import { HiOutlineHeart, HiHeart, HiOutlineDownload, HiOutlineDocumentDuplicate } from 'react-icons/hi';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

function StickerCard({ sticker, onFavoriteToggle }) {
  const [isFavorite, setIsFavorite] = useState(sticker.is_favorite || false);
  const [isCopying, setIsCopying] = useState(false);
  
  const handleFavoriteClick = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      const method = isFavorite ? 'DELETE' : 'POST';
      const response = await fetch(`http://localhost/sticker-library/api/index.php/favorites`, {
        method: method,
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ sticker_id: sticker.id }),
      });
      
      if (response.ok) {
        setIsFavorite(!isFavorite);
        if (onFavoriteToggle) {
          onFavoriteToggle(sticker.id, !isFavorite);
        }
        toast.success(isFavorite ? 'Removido dos favoritos' : 'Adicionado aos favoritos');
      }
    } catch (error) {
      console.error('Erro ao atualizar favorito:', error);
      // Toggle local para demonstração
      setIsFavorite(!isFavorite);
      toast.success(isFavorite ? 'Removido dos favoritos' : 'Adicionado aos favoritos');
    }
  };
  
  const handleDownload = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    try {
      // Registrar download
      await fetch(`http://localhost/sticker-library/api/index.php/stickers/${sticker.id}/download`, {
        method: 'POST',
      });
      
      // Criar link de download
      const link = document.createElement('a');
      link.href = `http://localhost/sticker-library/${sticker.image_path}`;
      link.download = `${sticker.name}.png`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      toast.success('Download iniciado!');
    } catch (error) {
      console.error('Erro ao baixar sticker:', error);
      // Download direto para demonstração
      const link = document.createElement('a');
      link.href = `http://localhost/sticker-library/${sticker.image_path}`;
      link.download = `${sticker.name}.png`;
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      toast.success('Download iniciado!');
    }
  };
  
  const handleCopy = () => {
    setIsCopying(true);
    setTimeout(() => {
      setIsCopying(false);
    }, 2000);
  };
  
  const imageUrl = sticker.image_path 
    ? `http://localhost/sticker-library/${sticker.image_path}`
    : `https://placehold.co/400x400/E8D5CC/8B5E3C?text=${encodeURIComponent(sticker.name || 'Sticker')}`;
  
  return (
    <div className="sticker-card animate-fade-in">
      {/* Image Container */}
      <div className="sticker-image-container">
        <img 
          src={imageUrl}
          alt={sticker.name}
          className="sticker-image"
          loading="lazy"
          onError={(e) => {
            e.target.src = `https://placehold.co/400x400/E8D5CC/8B5E3C?text=${encodeURIComponent(sticker.name || 'Sticker')}`;
          }}
        />
        
        {/* Favorite Button */}
        <button 
          className={`sticker-favorite-btn ${isFavorite ? 'active' : ''}`}
          onClick={handleFavoriteClick}
          aria-label={isFavorite ? 'Remover dos favoritos' : 'Adicionar aos favoritos'}
        >
          {isFavorite ? <HiHeart /> : <HiOutlineHeart />}
        </button>
        
        {/* Sticker Name */}
        <div className="sticker-name">{sticker.name}</div>
      </div>
      
      {/* Actions */}
      <div className="sticker-actions">
        <CopyToClipboard 
          text={imageUrl}
          onCopy={handleCopy}
        >
          <button className="sticker-action-btn primary">
            <HiOutlineDocumentDuplicate />
            Copiar
          </button>
        </CopyToClipboard>
        
        <button 
          className="sticker-action-btn secondary"
          onClick={handleDownload}
          aria-label="Baixar sticker"
        >
          <HiOutlineDownload />
        </button>
      </div>
    </div>
  );
}

export default StickerCard;
